import { Navigate } from 'react-router-dom';
import { checkPermission } from './checkPermission';
import { checkToken } from './checkToken';

const renderConditionalComponent = (permission, Component) => {
  const [isAuthenticated, user] = checkToken();
  if (isAuthenticated) {
    if (checkPermission(permission, user)) {
      return <Component />;
    } else {
      return <Navigate to={'/errors/permisos'} replace />;
    }
  } else {
    return <Navigate to={'/ingresar'} replace />;
  }
};

export default renderConditionalComponent;
